import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  OmnibusInitialize,
  OmnibusInitializeRetry,
  OmnibusInitializeSuccess,
} from './omnibus-initialization.actions';
import { OmnibusResultTypes } from './omnibus-initialization.interfaces';

@Injectable()
export class OmnibusInitializationFacade {
  constructor(private _store$: Store) {}

  public omnibusInitialize() {
    this._store$.dispatch(new OmnibusInitialize());
  }
  public omnibusInitializeSuccess(payload: OmnibusResultTypes[]) {
    this._store$.dispatch(new OmnibusInitializeSuccess(payload));
  }
  public omnibusInitializeRetry() {
    this._store$.dispatch(new OmnibusInitializeRetry());
  }
}
